'use strict';

wbApp.directive('wbLanguageAliasCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {

        function formatResult(item) {
            if (!item) { return; }

            return $translate.instant(item.text);
        }

        function formatSelection(item) {
            return $translate.instant(item.text);
        }


        return {
            restrict: 'A',
            require: 'ngModel',
            replace: true,
            priority: 1,
            link: function (scope, elm, attrs, controller) {
                $timeout(function () {
                    $(elm).select2({
                        minimumResultsForSearch: -1,
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        data: [
                            { id: 5, text: 'TXT_LANG_CS' },
                            { id: 27, text: 'TXT_LANG_SK' },
                            { id: 9, text: 'TXT_LANG_EN' },
                            { id: 7, text: 'TXT_LANG_DE' }
                        ]
                    });

                    elm.on('change', function (event) {
                        scope.$apply(function () {
                            controller.$setViewValue(event.val);
                        });
                    });

                    scope.$watch(attrs.ngModel, function (current, old) {
                        $(elm).select2('val', current || 5);
                    }, true);

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    if (attrs.ngEnable) {
                        scope.$watch(attrs.ngEnable, function (newVal) {
                            elm.select2('enable', !!newVal);
                        });
                    }
                }, 1);
            }
        }
    }]);
